import {
  DELETE_CONTAINED_VIEW,
  ADD_NAV_ITEM,
  ADD_RICH_MARK,
  EDIT_RICH_MARK,
  DELETE_NAV_ITEM,
  UPDATE_VIEW_TOOLBAR,
  APPLY_IMAGE_URL_MAP,
  IMPORT_STATE,
  ADD_CONTAINED_VIEW,
  ADD_NAV_ITEMS,
  DUPLICATE_NAV_ITEM,
  DUPLICATE_NAV_ITEM_BY_PAYLOAD,
  IMPORT_EDI,
  CHANGE_THEME_PALETTE,
  CHANGE_THEME_PALETTE_ALL,
  BATCH_UPDATE_MANDATORY_DEFAULTS,
  BATCH_SET_SCENE_FONT,
  PASTE_SCENE,
} from "../common/actions";
import i18n from "i18next";
import {
  changeProp,
  deleteProps,
  isDocument,
  isPage,
  isSection,
  isSlide,
  isContainedView,
  nextAvailName,
} from "../common/utils";
import Utils from "../common/utils";
import { applyUrlMapToViewToolbars } from "./applyImageUrlMap";

function toolbarElementCreator(state, action, containedView = false) {
  let doc_type;
  let id = containedView ? action.payload.mark.connection : action.payload.id;
  let type = containedView ? action.payload.view.type : action.payload.type;

  if (isPage(id)) {
    doc_type = i18n.t("page");
  }
  if (isSlide(type)) {
    doc_type = i18n.t("slide");
  }

  /* if(isDocument(type)) {
        doc_type = i18n.t('document');
    }*/

  if (isSection(id)) {
    doc_type = i18n.t("section");
  }

  if (isDocument(type)) {
    doc_type = i18n.t("Page");
  }

  let pagetitle = ""; // /*i18n.t('Title') +*/ doc_type;

  let name = action.payload.name
    ? action.payload.name
    : containedView
      ? action.payload.toolbar.viewName
      : doc_type;
  // name =nextAvailName(name, state, 'viewName');
  let background = action.payload.background ? action.payload.background.background : "#ffffff";
  let backgroundAttr = action.payload.background ? action.payload.background.backgroundAttr : "";
  let toolbar = {
    id: id,
    breadcrumb: isSlide(type) ? "hidden" : "reduced",
    doc_type: type,
    viewName: name,
    courseTitle: "hidden",
    documentSubtitle: "hidden",
    documentSubtitleContent: i18n.t("subtitle"),
    documentTitle:
      action.payload.hideTitles || (action.payload.toolbar && action.payload.toolbar.hideTitles)
        ? "hidden"
        : "expanded",
    documentTitleContent: pagetitle,
    numPage: "hidden",
    numPageContent: action.payload.position || "",
    customSize: 0,
    aspectRatio: true,
    background: background || "#ffffff",
    backgroundAttr: backgroundAttr || "",
    customMode: undefined,
    isMandatory: true,
    mandatoryType: "waitForTime",
    minTime: 3,
    autoNext: false,
    autoNextShowCta: false,
    sceneEndCta: false,
  };

  return toolbar;
}

export default function (state = {}, action = {}) {
  let newState;
  switch (action.type) {
    case ADD_NAV_ITEM:
      return changeProp(state, action.payload.id, toolbarElementCreator(state, action));
    case ADD_NAV_ITEMS:
      let nav_items = {};
      action.payload.navs.forEach((nav) => {
        nav_items[nav.id] = toolbarElementCreator(state, { type: ADD_NAV_ITEM, payload: nav });
      });
      return { ...state, ...nav_items };
    case ADD_RICH_MARK:
    case EDIT_RICH_MARK:
      if (action.payload.mark.connectMode === "new") {
        return changeProp(
          state,
          action.payload.view.id,
          toolbarElementCreator(state, action, isContainedView(action.payload.mark.connection))
        );
      }
      return state;
    case ADD_CONTAINED_VIEW:
      return changeProp(state, action.payload.id, toolbarElementCreator(state, action.view));
    case DELETE_CONTAINED_VIEW:
      return deleteProps(state, action.payload.ids);
    case DELETE_NAV_ITEM:
      return deleteProps(state, action.payload.ids);
    case UPDATE_VIEW_TOOLBAR: {
      // Invariant: `background` and `themeHtml` are mutually exclusive. A
      // payload must send at most one of them as a non-empty value; if both
      // are non-empty, neither guard below fires and both fields persist,
      // violating the invariant. ThemePaletteModal enforces this via its
      // customMode branching; other callers must too.
      newState = {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          ...action.payload,
        },
      };
      const entry = newState[action.payload.id];
      const p = action.payload;

      // Image/Color write → clear HTML + theme-vars + paletteId.
      // themeId left to whatever the payload set (modal sends "custom").
      if (p.background !== undefined && p.background !== "" && p.themeHtml === undefined) {
        entry.themeHtml = "";
        entry.themeCssVariables = {};
        entry.paletteId = "";
      }

      // HTML write (non-empty) → clear image + attr + theme-vars + paletteId.
      if (
        typeof p.themeHtml === "string" &&
        p.themeHtml.trim() !== "" &&
        p.background === undefined
      ) {
        entry.background = "";
        entry.backgroundAttr = "";
        entry.themeCssVariables = {};
        entry.paletteId = "";
      }

      return newState;
    }
    case APPLY_IMAGE_URL_MAP:
      // Bulk logo: swap every scene background image from the job urlMap.
      return applyUrlMapToViewToolbars(state, action.payload.urlMap);
    case IMPORT_STATE:
      return action.payload.present.viewToolbarsById || state;
    case IMPORT_EDI:
      return { ...state, ...action.payload.state.viewToolbarsById };
    case DUPLICATE_NAV_ITEM:
      return {
        ...state,
        [action.payload.newId]: {
          ...state[action.payload.id],
          id: action.payload.newId,
          viewName: state[action.payload.id].viewName + " " + i18n.t("repeatedItemCopied"),
        },
      };
    case DUPLICATE_NAV_ITEM_BY_PAYLOAD:
      return {
        ...state,
        [action.payload.newId]: {
          ...action.payload.viewToolbar,
          id: action.payload.newId,
          viewName: action.payload.viewToolbar.viewName + " " + i18n.t("repeatedItemCopied"),
        },
      };
    case PASTE_SCENE:
      return {
        ...state,
        [action.payload.newSceneId]: {
          ...action.payload.viewToolbar,
          id: action.payload.newSceneId,
        },
      };
    case CHANGE_THEME_PALETTE:
      return {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          themeId: action.payload.themeId,
          paletteId: action.payload.paletteId,
          themeHtml: action.payload.themeHtml,
          themeCssVariables: action.payload.themeCssVariables,
          background: "",
          backgroundAttr: "",
          customMode: undefined,
        },
      };
    case CHANGE_THEME_PALETTE_ALL: {
      const updated = {};
      Object.keys(state).forEach((id) => {
        updated[id] = {
          ...state[id],
          themeId: action.payload.themeId,
          paletteId: action.payload.paletteId,
          themeHtml: action.payload.themeHtml,
          themeCssVariables: action.payload.themeCssVariables,
          background: "",
          backgroundAttr: "",
          customMode: undefined,
        };
      });
      return { ...state, ...updated };
    }
    case BATCH_SET_SCENE_FONT: {
      const { fontFamily, navItemId } = action.payload;
      // `navItemId` = scene scope (canvas font button); no id = whole course.
      if (navItemId) {
        if (!state[navItemId]) return state;
        return { ...state, [navItemId]: { ...state[navItemId], fontFamily } };
      }
      const next = {};
      for (const id of Object.keys(state)) {
        // VERIFY-LIVE: confirm the canvas render consumes viewToolbar.fontFamily.
        // Verified the render path (EditorCanvasSli.jsx:179-183 spreads toolbar.themeCssVariables
        // as inline scene style; VisorCanvasSli has no font read; fonts today are CKEditor-inline
        // per text box). There is NO existing scene-level fontFamily read and NO theme font CSS
        // variable, so we store the plain `fontFamily` on the viewToolbar (+ globalConfig default
        // below). The render layer must be wired to read this var in a follow-up (out of scope here).
        next[id] = { ...state[id], fontFamily };
      }
      return next;
    }
    case BATCH_UPDATE_MANDATORY_DEFAULTS: {
      const { mandatory, question } = action.payload || {};
      if (!mandatory) return state;
      const questionIds = (question && question.mandatory && question.sceneIds) || [];
      const { minTime, ...rest } = mandatory;
      let payload;
      if (typeof minTime === "number") {
        const sd = rest.isMandatory && minTime > 0 ? minTime : null;
        payload = { ...rest, slideDuration: sd };
      } else if (rest.isMandatory === false) {
        payload = { ...rest, slideDuration: null };
      } else {
        payload = { ...rest };
      }
      const next = {};
      for (const id of Object.keys(state)) {
        next[id] = {
          ...state[id],
          ...(questionIds.includes(id) ? question.mandatory : payload),
        };
      }
      return next;
    }
    default:
      return state;
  }
}
